/**
 * New strings of the "Transcrire" page, FR and EN. Keys that already exist in
 * translations.ts stay in use (t.loadAudios, t.audioXofY, t.french...).
 */
export const transcriptionAudioCopy = {
  fr: {
    instructions: [
      "Écoutez l'audio en entier, autant de fois que nécessaire.",
      "Écrivez exactement ce que vous entendez, dans la langue parlée.",
      "Ajoutez la traduction en français si vous la connaissez.",
      "Passez un audio inaudible ou dans une autre langue.",
    ],
    resumeTitle: "Reprise de votre session",
    resumeBody: "Elle reprend toute seule dès que la langue est connue.",
    sourceLabel: "À écouter",
    writeLabel: "Votre transcription",
    batchLabel: "Audios de la série",
    nextBatch: "Audios suivants",
    skip: "Passer cet audio",
    send: "Envoyer",
    playHint: "lecture / pause",
    keyboardShow: "Afficher le clavier",
    keyboardHide: "Masquer le clavier",
    notProvided: "Non renseigné",
    pageMeta: "Série {page}",
    emptyTitle: "Aucun audio à transcrire pour l'instant",
    emptyBody: "Revenez plus tard ou choisissez une autre langue.",
    doneDescription: "Il n'y a plus d'audio à transcrire dans cette langue pour le moment. Merci pour vos transcriptions.",
    doneSent: "Transcriptions envoyées",
    doneBack: "Revenir à la session",
  },
  en: {
    instructions: [
      "Listen to the whole audio, as many times as you need.",
      "Write exactly what you hear, in the spoken language.",
      "Add the French translation if you know it.",
      "Skip an audio you cannot hear or that is in another language.",
    ],
    resumeTitle: "Resuming your session",
    resumeBody: "It picks up on its own once the language is known.",
    sourceLabel: "To listen to",
    writeLabel: "Your transcription",
    batchLabel: "Audios in this set",
    nextBatch: "Next audios",
    skip: "Skip this audio",
    send: "Send",
    playHint: "play / pause",
    keyboardShow: "Show the keyboard",
    keyboardHide: "Hide the keyboard",
    notProvided: "Not provided",
    pageMeta: "Set {page}",
    emptyTitle: "No audio to transcribe right now",
    emptyBody: "Come back later or pick another language.",
    doneDescription: "There is no audio left to transcribe in this language for now. Thank you for your transcriptions.",
    doneSent: "Transcriptions sent",
    doneBack: "Back to the session",
  },
} as const;

export type TranscriptionAudioCopy = {
  [K in keyof (typeof transcriptionAudioCopy)["fr"]]: K extends "instructions" ? readonly string[] : string;
};
